import { AnyBoosterType, BoosterType, PreBoosterType } from './BoosterType';
import BaseBoosterBehavior from './BoosterBehavior/BaseBoosterBehavior';
import JokerBoosterBehavior from './BoosterBehavior/JokerBoosterBehavior';
import UndoBoosterBehavior from './BoosterBehavior/UndoBoosterBehavior';
import TNTBoosterBehavior from './BoosterBehavior/TNTBoosterBehavior';
import ShuffleBoosterBehavior from './BoosterBehavior/ShuffleBoosterBehavior';
import BullsEyeBoosterBehavior from './BoosterBehavior/BullsEyeBoosterBehavior';
import PlusFiveBoosterBehavior from './BoosterBehavior/PlusFiveBoosterBehavior';
import PlusThreeBoosterBehavior from './BoosterBehavior/PlusThreeBoosterBehavior';
import PlusOneBoosterBehavior from './BoosterBehavior/PlusOneBoosterBehavior';
import { ResourceDataSet } from '../../Utility/Tracking/DataSet/Resource';
import RemoveThreePreBoosterBehavior from './BoosterBehavior/RemoveThreePreBoosterBehavior';
import JokerPreBoosterBehavior from './BoosterBehavior/JokerPreBoosterBehavior';
import CanisterPreBoosterBehavior from './BoosterBehavior/CanisterPreBoosterBehavior';

type tBoosterType = Record<
    AnyBoosterType,
    {
        behavior: typeof BaseBoosterBehavior;
        receivedEvent?: keyof ResourceDataSet;
        usedEvent?: keyof ResourceDataSet;
        coinsEvent?: keyof ResourceDataSet;
    }
>;

export const BoosterTypeMap: tBoosterType = {
    [BoosterType.JOKER]: {
        behavior: JokerBoosterBehavior,
        receivedEvent: 'tJokerReceived',
        usedEvent: 'tJokerUsed',
        coinsEvent: 'tJokerCoins',
    },
    [BoosterType.UNDO]: {
        behavior: UndoBoosterBehavior,
        receivedEvent: 'tUndoReceived',
        usedEvent: 'tUndoUsed',
        coinsEvent: 'tUndoCoins',
    },
    [BoosterType.TNT]: {
        behavior: TNTBoosterBehavior,
        receivedEvent: 'tMassRemoveReceived',
        usedEvent: 'tMassRemoveUsed',
        coinsEvent: 'tMassRemoveCoins',
    },
    [BoosterType.SHUFFLE]: {
        behavior: ShuffleBoosterBehavior,
        receivedEvent: 'tChangerReceived',
        usedEvent: 'tChangerUsed',
        coinsEvent: 'tChangerCoins',
    },
    [BoosterType.BULLS_EYE]: {
        behavior: BullsEyeBoosterBehavior,
        receivedEvent: 'tRemoveOneReceived',
        usedEvent: 'tRemoveOneUsed',
        coinsEvent: 'tRemoveOneCoins',
    },
    [BoosterType.PLUS_FIVE]: {
        behavior: PlusFiveBoosterBehavior,
        receivedEvent: 'tPlus5Received',
        usedEvent: 'tPlus5Used',
        coinsEvent: 'tExtraCardsCoins',
    },
    [BoosterType.PLUS_THREE]: {
        behavior: PlusThreeBoosterBehavior,
    },
    [BoosterType.PLUS_ONE]: {
        behavior: PlusOneBoosterBehavior,
        receivedEvent: 'tExtraCardsReceived',
        coinsEvent: 'tExtraCardsCoins',
    },
    [PreBoosterType.REMOVE_THREE]: {
        receivedEvent: 'tRemoveCardsBoostersReceived',
        usedEvent: 'tRemoveCardsBoostersUsed',
        coinsEvent: 'tRemoveCardsBoostersCoins',
        behavior: RemoveThreePreBoosterBehavior,
    },
    [PreBoosterType.JOKER]: {
        receivedEvent: 'tExtraWildcardsBoostersReceived',
        usedEvent: 'tExtraWildcardsBoostersUsed',
        coinsEvent: 'tExtraWildcardsBoostersCoins',
        behavior: JokerPreBoosterBehavior,
    },
    [PreBoosterType.CANISTER]: {
        receivedEvent: 'tCanisterCardBoostersReceived',
        usedEvent: 'tCanisterCardBoostersUsed',
        coinsEvent: 'tCanisterCardBoostersCoins',
        behavior: CanisterPreBoosterBehavior,
    },
};
